import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "transition duration-150 w-7 h-7" }
const _hoisted_2 = {
  key: 0,
  class: "h-full w-full"
}
const _hoisted_3 = {
  class: "w-full h-full",
  viewBox: "0 0 100 100"
}
const _hoisted_4 = ["r"]
const _hoisted_5 = ["r", "stroke-dasharray", "stroke-dashoffset"]
const _hoisted_6 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`w-full h-full`)
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.concluded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(), _createElementBlock("svg", _hoisted_3, [
              _createElementVNode("circle", {
                class: "text-gray-400 stroke-current",
                "stroke-width": "10",
                cx: "50",
                cy: "50",
                r: _ctx.radius,
                fill: "transparent"
              }, null, 8, _hoisted_4),
              _createElementVNode("circle", {
                class: "text-h-success-500 progress-ring__circle stroke-current",
                "stroke-width": "10",
                "stroke-linecap": "round",
                cx: "50",
                cy: "50",
                r: _ctx.radius,
                fill: "transparent",
                "stroke-dasharray": _ctx.circumference,
                "stroke-dashoffset": _ctx.offset
              }, null, 8, _hoisted_5)
            ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.concluded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_v_icon, {
              name: "hi-solid-check-circle",
              class: "text-green-600 w-full h-full"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}